define.alias("ember-composable-helpers/helpers/map-by", "settings/helpers/map-by");